// extracted by mini-css-extract-plugin
module.exports = {"member-item-list":"style_member-item-list__1oxDS"};